
export default {
  name: 'AppCarousel',

  props: {
    presentingMode: Boolean,
    hoverMode: Boolean,
    stopTransitionNavigation: Boolean
  },

  data () {
    return {
      // default scroll steps of 100px
      scrollStepSize: 100,
      autoplayIntervalId: null,
      mouseover: false,
      padding: 0,
      transition: false
    }
  },

  computed: {
    scrollContainerStyles () {
      let spacingSize = 50

      // (this.mouseover || this.hoverMode)
      if (process.browser && (window.innerWidth >= 1024 && (this.mouseover || this.hoverMode))) {
        spacingSize = 1000
      }

      /*
        When overflow-x is set to anything != visible, overflow-y "stops working" per W3C spec
        https://stackoverflow.com/a/6433475/2078468
        Quite a hack but it seems to be the only way to work around this limitation
        https://stackoverflow.com/a/39554003/2078468
        It allows child elements to overflow up to 200px on the Y axis
      */

      return {
        'padding-bottom': spacingSize + 'px',
        'margin-bottom': '-' + spacingSize + 'px',
        'padding-top': spacingSize + 'px',
        'margin-top': '-' + spacingSize + 'px'
      }
    }
  },

  watch: {
    presentingMode: {
      handler (newValue) {
        if (this.autoplayIntervalId) {
          clearInterval(this.autoplayIntervalId)
        }

        if (!newValue) {
          return
        }

        this.autoplayIntervalId = window.setInterval(() => {
          this.scroll(1)

          this.startOverIfDone()
        }, 5000)
      },
      immediate: true
    }
  },

  mounted () {
    if (
      !this.$refs.grid ||
      !this.$refs.grid.childNodes ||
      !this.$refs.grid.childNodes[0]
    ) {
      return
    }

    this.scrollStepSize = this.$refs.grid.childNodes[0].offsetWidth

    if (window.innerWidth <= 640) {
      this.scroll(1)
    }
  },

  methods: {
    transitionStart () {
      this.transition = true
    },
    transitionEnd () {
      this.transition = false
    },
    scroll (direction) {
      if (this.stopTransitionNavigation && this.transition) {
        return
      }

      const scrollContainer = this.$refs['scroll-container']

      if (!scrollContainer) {
        return
      }

      this.scrollTo(scrollContainer, scrollContainer.scrollLeft + (direction * this.scrollStepSize))

      if (this.hoverMode) {
        this.$emit('push-theme')

        if (this.$store.state.resetThemeCarousel) {
          this.scrollTo(scrollContainer, scrollContainer.scrollLeft + (-15 * this.scrollStepSize))
        }
      }
    },

    startOverIfDone () {
      const scrollContainer = this.$refs['scroll-container']
      const grid = this.$refs.grid

      if (!scrollContainer || !grid) {
        return
      }

      const lastItem = grid.childNodes[grid.childNodes.length - 1]

      if (!lastItem) {
        return
      }

      const lastItemBounds = lastItem.getBoundingClientRect()
      const scrollContainerBounds = scrollContainer.getBoundingClientRect()

      if (lastItemBounds.x + lastItemBounds.width <= scrollContainerBounds.x + scrollContainerBounds.width) {
        this.scrollTo(scrollContainer, 0)
      }
    },

    scrollTo (scrollContainer, x) {
      if (typeof scrollContainer.scroll === 'function') {
        scrollContainer.scroll({ left: x, behavior: 'smooth' })
      } else {
        scrollContainer.scrollLeft = x
      }
    }
  }
}
